import { render, staticRenderFns } from "./LandDataPopup.vue?vue&type=template&id=10298482&"
import script from "./LandDataPopup.vue?vue&type=script&lang=js&"
export * from "./LandDataPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports